import { NotAllowedMessage } from "@components/AccessControl/AccessControl";
import { Block } from "@components/Block/Block";
import { IMR as IMRComponent } from "@components/IMR/IMR";
import { SectionImpression } from "@components/SectionImpression/SectionImpression";
import { useAuthData } from "@contexts";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { CMSFragmentProps, IMR } from "@types";
import React from "react";

import PaywallTeaserIllustration from "../../images/paywallTeaserIllustration.svg";
import { NumericAccessLevel } from "../../types/NumericAccessLevel";
import style from "./style.module.scss";

interface PaywallTeaserProps {
    title: string;
    description: string;
    code: IMR;
    fragment: CMSFragmentProps;
    commercial: boolean;
    teaserTitle: string;
}

export const PaywallTeaser = ({
    title,
    description,
    code,
    fragment,
    commercial = false,
    teaserTitle,
}: PaywallTeaserProps): JSX.Element => {
    const authData = useAuthData();
    const dynamicAttribute: Record<string, boolean> = {};
    if (authData?.level === NumericAccessLevel.level3) {
        dynamicAttribute["data-nosnippet"] = true;
    }
    const fragmentBlock = fragment && { fragment: { fragment: [fragment] } };
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <div className={style.flex} {...dynamicAttribute} data-test-id="Paywall.Teaser">
            {fragmentBlock && (
                <SectionImpression name={teaserTitle} position={1}>
                    <section data-test-id="teaser-fragment" id="fragmentSection">
                        <div className={style.paywallBlock}>
                            <Block content={fragmentBlock}></Block>
                        </div>
                    </section>
                </SectionImpression>
            )}

            {!fragment && (
                <section className={style.center} data-test-id="teaser-metas" id="metaSection">
                    {title && (
                        <Typography weight="700" size="2xl" component="h3" dataTestId="meta-title">
                            {title}
                        </Typography>
                    )}
                    <span>
                        {description && (
                            <Typography component="pre" dataTestId="meta-description">
                                {description}
                            </Typography>
                        )}
                    </span>
                    {!fragment && !title && !description && <NotAllowedMessage commercial={commercial} />}
                </section>
            )}
            {code && (
                <SectionImpression name={"IMR"} position={1}>
                    <Typography size="s" component="p" color="light" dataTestId="teaser-code" className={style.imr}>
                        <IMRComponent code={code?.code} date_of_preparation={code?.date_of_preparation} />
                    </Typography>
                </SectionImpression>
            )}
            {!fragment && <img src={PaywallTeaserIllustration} data-test-id="teaser-illustration" />}
        </div>
    );
};

export default PaywallTeaser;
